<template>
  <div class="my-list">
    <div class="post-list" v-if="dataList&&dataList.length">
      <div class="post-info" v-for="item in dataList" :key="item.id">
        <div class="post-info-img"  @click="routerHandle(item)">
          <img :src="item.userImgUrl" width="74px" height="74px" :alt="item.downloadDataName"/>
        </div>
        <div class="post-detail"  @click="routerHandle(item)">
          <div class="post-detail-title overell">{{item.downloadDataName}}</div>
          <div class="post-detail-time">
            <span>下载时间：{{item.createTime}}</span>
          </div>
        </div>
        <div class="post-status">
          <img :src="BASE_URL + 'img/download.png'" width="14px" height="14px" alt="下载"/>
          <span @click.stop="download(item)">下载</span>
        </div>
      </div>
    </div>
    <div v-else>
      <div style="text-align:center">
        <img :src="BASE_URL + 'img/kong.png'" alt="暂无数据">
      </div>
    </div>
    <div class="doclist-pagination" v-if="dataList&&dataList.length">
      <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
      <div class="doclist-omit">{{lastOmit}}</div>
      <ul>
        <li :class="item === currentPage?'pageactive':''" v-for="item in pageList" :key="item" @click="changePageTo(item)">{{item}}</li>
      </ul>
      <div class="doclist-omit">{{nextOmit}}</div>
      <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
      <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
      <div class="doclist-jump" @click="jumpFarPage">确定</div>
    </div>
  </div>
</template>

<script>
import { track } from '@/utils/knowledgeEventTracking'
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      status: '',
      dataList: [],
      // 分页
      currentPage: 1, // 当前页
      totalPage: 0, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [],
      jumpTargetPage: 1 // 跳转页
    }
  },
  computed: {
    // 计算属性的 getter
  },
  mounted () {
    this.getDataList(this.currentPage)
  },
  methods: {
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      this.getDataList(page)
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.changePageTo(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    getDataList (currentPage = this.currentPage) {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/userdownloaddatainfo/myDownloadList`, {
        'page': currentPage,
        'limit': 10
      })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.dataList = data.data.data || []
            this.totalPage = Math.ceil(Number(data.data.count) / 10)
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.setPageTo(currentPage)
        })
    },
    setPageTo (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    changeStatus (index) {
      this.status = index
      this.getDataList(1)
    },
    routerHandle (item) {
      track.clickDocDetail(item.fileTitle)
      this.$router.push({
        name: 'bookDocDetail',
        query: {
          fileId: item.downloadDateId
        }
      })
    },
    // download (item) {
    //   this.$http.get(`${window.SITE_CONFIG['apiURL']}/alioss/sysossali/isObjectExist/${item.ossId}`)
    //   .then(data => {
    //     // let a = document.createElement('a')
    //     track.clickDocDownload(item.fileTitle)
    //     window.location.href = `${window.SITE_CONFIG['apiURL']}/technicaldocumentation/technicalfile/aliOssDownLoad/${item.downloadDateId}/${this.$store.state.userInfo.userId}`
    //     // a.click();
    //   })
    //   .catch(err => {
    //     this.$message.warning('该文件已失效')
    //   })
    //   // let a = document.createElement('a')
    //   // a.href = `${window.SITE_CONFIG['apiURL']}/technicaldocumentation/technicalfile/aliOssDownLoad/${item.id}/${this.$store.state.userInfo.userId}`
    //   // a.click();
    // },
    download (item) {
      if (this.$store.state.user.id) {
        this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/fileupload/alioss/isObjectExist/${item.ossId}`)
          .then(({ data }) => {
            track.clickDocDownload(item.downloadDataName)
            this.downloadFile(item)
          })
          .catch(() => {
            this.$message.warning('该文件不存在')
          })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    downloadFile (item) {
      // console.log(item)
      this.$confirm(
        `下载${item.downloadDataName}需要 ${item.score}积分?`,
        '提示',
        {
          confirmButtonText: '确定下载',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          return this.$http.post(`${window.SITE_CONFIG['apiURL']}/technicaldocumentation/technicalfile/userFileAddMinsPoint`, {
            id: item.id
          })
        })
        .then(() => {
          let a = document.createElement('a')
          a.href = `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/aliOssDownLoad/${item.id}/${this.$store.state.user.id}`
          a.click()
        })
        .catch((err) => {
          if (err !== 'cancel') {
            this.$message.warning('积分不足')
          }
        })
    }
  }
}
</script>
<style scoped lang="scss">
.my-list{
  margin: 0 79px;
}
.tabs{
  height: 48px;
  margin: 0 69px;
}
.tab-item{
  display: inline-block;
  padding: 12px 16px;
  text-align: center;
  background: #FFFFFF;
  /* box-shadow: inset 0 -1px 0 0 #DDDDDD; */
  width: 88px;
  height: 46px;
  line-height: 22px;
  font-size: 14px;
  letter-spacing: 0;
  margin-right: 24px;
  cursor: pointer;
}
.tab-item-active{
  color: #1D65A8;
  border-bottom: 2px solid #1D65A8;
}
.tab-item-content{
  padding-top: 10px;
}
.post-info{
  margin-top: 30px;
  width: 100%;
  display: flex;
  padding-bottom: 28px;
  border-bottom: 1px solid #eee;
}
.post-info-img{
  min-width: 74px;
  width: 74px;
  height: 74px;
}
.post-info-img img{
  width: 74px;
  height: 74px;
  border-radius: 37px;
  overflow: hidden;
}
.post-detail {
  max-width: 700px;
  padding-right: 20px;
  padding-left: 30px;
  cursor: pointer;
}
.post-detail-title{
  width: 630px;
  text-align: left;
  line-height: 22px;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0.6px;
  height: 22px;
  margin-bottom: 10px;
}
.post-detail-time{
  line-height: 17px;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0.6px;
  padding-bottom: 14px;
  // border-bottom: 1px solid #eee;
}
.post-status{
  width: 100%;
  min-width: 50px;
  text-align: right;
  line-height: 20px;
  font-size: 12px;
  color: #1D65A8;
  letter-spacing: 0.51px;
  height: 20px;
}
.post-status span{
  cursor: pointer;
}
.post-status-success{
  line-height: 20px;
  font-size: 14px;
  color: #1D65A8;
  width: 56px;
  height: 20px;
}
.post-status-ing{
  text-align: left;
  line-height: 20px;
  font-size: 14px;
  color: #E2980A;
  width: 102px;
}
.post-status-fail{
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  color: #BF1B22;
  width: 56px;
  height: 20px;
}
</style>
